export default __webpack_public_path__ + "static/media/28.4d089e65.jpg";